import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConsultaService {
    private connection: any;
      private messageSource = new Subject<string>();
    static atualizarConsulta = new EventEmitter<any>();

    constructor() { }

    initConnection() {
        if (this.connection)
            return;

        let current = this;

        abp.signalr.startConnection(abp.appPath + 'signalr-consultaHub', function (connection) {
            current.connection = connection;

            connection.on('atualizacaoConsulta', function (message) {
                if (abp.session.userId != message.remetenteId) {
                    current.changeMessage('atualizacaoConsulta', message);
                }
            })
        }).then(function (conncetion) {
            abp.log.debug('Connected to notificationHub server!');
        });
    }

    private changeMessage(message: string, dados: any) {
        ConsultaService.atualizarConsulta.emit(dados);
        this.messageSource.next(message);
    }

}
